import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import BacktestService from "../../../../../../service/backtest.service";
import DatePicker from "react-datepicker";
import moment from "moment";
import { ExcelRenderer } from "react-excel-renderer";
import Helper from "../../helper/Helper";
import UploadFileButton from "../../../../../common/buttons/uploadFileButton";
import "react-datepicker/dist/react-datepicker.css";
import "./pannel.styles.scss";
// import ModalComponent from "../../../../../common/modal/modal";

class Pannel extends Component {
  state = {
    pannelSearchValue: "",
    autoCompleteData: [],
    ajax_in_progress: false,
    displayAutoCompleteOp: false,
    pannel_fund_name: "",
    pannel_asset_class: "",
    pannel_classification: "",
    pannel_symbol: "",
    pannel_style: "",
    pannel_date: null,
    pannelAllocationValue: null,
    historical_upload_error: false,
    historical_error_name: "",
    onlyHeaderPresentWarning: false,
    wrongFormatUploaded: false,
    SecurityAlreadyUploaded: false,
  };

  componentDidMount() {
    document.addEventListener("click", this.handleClickOutside);
  }
  componentWillUnmount() {
    document.removeEventListener("click", this.handleClickOutside);
  }
  searchHandler = (e) => {
    let { value } = e.target;
    this.setState({
      pannelSearchValue: value,
    });
    this.getAutoCompleteData();
  };
  getAutoCompleteData = () => {
    let { pannelSearchValue } = this.state;
    if (pannelSearchValue.length >= 3) {
      if (!this.state.ajax_in_progress) {
        this.setState({
          ajax_in_progress: true,
        });
        BacktestService.getAutocomplete(`${pannelSearchValue}`).then((res) => {
          this.setState({
            ajax_in_progress: false,
          });
          if (res) {
            this.setState({
              autoCompleteData: res,
              displayAutoCompleteOp: true,
            });
          }
        });
      }
    }
  };
  suggestionHandler = (e) => {
    const { autoCompleteData } = this.state;
    let index = e.target.getAttribute("index");
    let data = autoCompleteData[index];

    console.log(autoCompleteData);
    let pannel_fund_name = data["fund_name"];
    let pannel_asset_class = data["asset_class"];
    let pannel_classification = data["classification"];
    let pannel_symbol = data["symbol"];
    let pannel_style = data["style"];

    // clear list on selecting any option
    this.setState({
      pannel_fund_name,
      pannel_asset_class,
      pannel_classification,
      pannel_symbol,
      pannel_style,
      displayAutoCompleteOp: false,
      showPannelData: true,
    });
  };
  addRow = (value) => {
    const {
      pannel_fund_name,
      pannel_asset_class,
      pannel_classification,
      pannel_symbol,
      pannel_style,
      pannelAllocationValue,
      pannel_date,
    } = this.state;
    const {
      AddManualSecurity,
      AddManualSecurityToUniverse,
      AddSecurityToMyUniverse,
      addRowToggleHandler,
      portfolio,
      SecurityAddedManually,
      AddManualSecurityMyUniverse,
      symbols,
    } = this.props;
    // date without time stamp
    let nowDate = new Date();
    let date =
      nowDate.getFullYear() +
      "/" +
      (nowDate.getMonth() + 1) +
      "/" +
      nowDate.getDate();

    //----
    let obj = {
      new_classification: pannel_classification,
      new_style: pannel_style,
      symbol: pannel_symbol,
      fund_name: pannel_fund_name,
      new_fund_type: "",
      fund_asset_class_focus: pannel_asset_class,
      date: pannel_date ? pannel_date : new Date(date),
      val: pannelAllocationValue,
    };

    if (AddManualSecurity) {
      let obj = {
        new_classification: pannel_classification,
        new_style: pannel_style,
        symbol: pannel_symbol,
        fund_name: pannel_fund_name,
        new_fund_type: "",
        fund_asset_class_focus: pannel_asset_class,
        val: pannelAllocationValue,
      };
      //SecurityAddedManually.some(e => e.fund_name === pannel_fund_name) ? null : AddManualSecurityToUniverse(obj);
      let tortoiseSelection =
        AddManualSecurity && AddManualSecurityMyUniverse ? portfolio : symbols;
      if (tortoiseSelection.some((e) => e.fund_name === pannel_fund_name)) {
        this.setState({
          SecurityAlreadyUploaded: true,
        });
        return null;
      } else {
        AddManualSecurityToUniverse(obj);
        AddSecurityToMyUniverse(obj);
        addRowToggleHandler();
      }
    } else {
      this.props.addSymbol(obj);
      this.props.addRowHandler();
    }
    this.setState({
      autoComplete: [],
      pannel_fund_name: "",
      pannel_asset_class: "",
      pannel_classification: "",
      pannel_symbol: "",
      pannel_style: "",
      pannelAllocationValue: null,
      pannel_date: null,
    });
  };

  SecurityAlreadyPresentHandler = (value) => {
    //value -> true false ;
    const {
      pannel_fund_name,
      pannel_asset_class,
      pannel_classification,
      pannel_symbol,
      pannel_style,
      pannelAllocationValue,
    } = this.state;
    let obj = {
      new_classification: pannel_classification,
      new_style: pannel_style,
      symbol: pannel_symbol,
      fund_name: pannel_fund_name,
      new_fund_type: "",
      fund_asset_class_focus: pannel_asset_class,
      val: pannelAllocationValue,
    };
    let {
      AddSecurityToMyUniverse,
      addRowToggleHandler,
      AddManualSecurityToUniverse,
    } = this.props;
    if (value) {
      AddManualSecurityToUniverse(obj);
      AddSecurityToMyUniverse(obj);
    }
    this.setState({
      SecurityAlreadyUploaded: false,
      autoComplete: [],
      pannel_fund_name: "",
      pannel_asset_class: "",
      pannel_classification: "",
      pannel_symbol: "",
      pannel_style: "",
      pannelAllocationValue: null,
      pannel_date: null,
    });
    addRowToggleHandler();
  };
  cancelHandler = () => {
    this.props.addRowToggleHandler();
    this.setState({
      autoComplete: [],
      pannel_fund_name: "",
      pannel_asset_class: "",
      pannel_classification: "",
      pannel_symbol: "",
      pannel_style: "",
      pannelAllocationValue: null,
      pannel_date: null,
    });
  };
  //handle click outside
  handleClickOutside = (event) => {
    let { displayAutoCompleteOp } = this.state;
    if (displayAutoCompleteOp) {
      setTimeout(() => {
        this.setState({
          displayAutoCompleteOp: false,
        });
      }, 100);
    }
  };
  xlsxHandler = (e) => {
    const {
      setHistoricalReturns,
      uploadErrorCallBack,
      uploadEmptyDataHandler,
      uploadedEmptyCellHandler,
    } = this.props;
    let file = e.target.files[0];
    if (
      file &&
      file.name &&
      (file.name.includes(".xls") || file.name.includes(".xlsx"))
    ) {
      ExcelRenderer(file, (err, res) => {
        if (err) {
          console.log("error");
        } else {
          const response = res["rows"].filter((e) => e.length);

          console.log(response);
          const heading = response[0].map((e) => e.toLowerCase().trim());
          const data = response.slice(1, response.length);
          const getIndex = (string) => {
            return heading.indexOf(string);
          };
          console.log(response, heading, data);

          let date_index = getIndex("date");
          let returns_index = getIndex("returns");

          // getting which column has error
          const getStatus = () => {
            if (date_index === -1) {
              this.setState({
                historical_upload_error: true,
                historical_error_name: "date",
              });
              uploadErrorCallBack(true, "date");
              return;
            } else if (returns_index === -1) {
              this.setState({
                historical_upload_error: true,
                historical_error_name: "returns",
              });
              uploadErrorCallBack(true, "returns");
              return;
            } else {
              this.setState({
                historical_upload_error: false,
                historical_error_name: "",
              });
              uploadErrorCallBack(false, "");
            }
          };
          getStatus();

          // check if uploaded empty data
          if (data.length === 0) {
            uploadEmptyDataHandler(true);
            setHistoricalReturns([]);
          } else {
            uploadEmptyDataHandler(false);
          }
          uploadedEmptyCellHandler(false);
          // console.log(date_index, returns_index);
          let condition =
            heading.length > 0 &&
            heading[date_index] &&
            heading[returns_index] &&
            heading[date_index].toLowerCase() === "date" &&
            heading[returns_index].toLowerCase() === "returns" &&
            data.length > 0;

          if (condition) {
            this.setState({
              historical_upload_error: false,
            });
            uploadErrorCallBack(false, "");
            let arr = [];

            for (let i = 0; i < data.length; i++) {
              let obj = {};

              let date = data[i][date_index]
                ? Helper.ExcelDateToJSDate(data[i][date_index])
                : "";
              // obj["date"] = date;
              if (
                typeof data[i][date_index] !== "number" ||
                typeof data[i][returns_index] !== "number"
              ) {
                uploadedEmptyCellHandler(true);
                continue;
              }
              obj["returns"] = data[i][returns_index]
                ? data[i][returns_index]
                : null;
              obj["date"] = date == "" ? "" : moment(date).format("MM/DD/YYYY");
              obj["id"] = i;
              arr.push(obj);
            }
            console.log(arr);

            setHistoricalReturns(arr);
            this.props.callBack();
            document.getElementById("upload_historical_returns").value = "";
          } else {
            document.getElementById("upload_historical_returns").value = "";
            this.setState({
              historical_upload_error: true,
            });
            // uploadErrorCallBack(true, null);
          }
        }
      });
    } else {
      this.setState({
        wrongFormatUploaded: true,
      });
      setTimeout(() => {
        this.setState({
          wrongFormatUploaded: false,
        });
      }, 5000);
      document.getElementById("upload_historical_returns").value = "";
    }
  };
  render() {
    const { showAddRowModel, addRowToggleHandler } = this.props;
    const {
      displayAutoCompleteOp,
      autoCompleteData,
      pannel_fund_name,
      pannel_asset_class,
      pannel_classification,
      pannel_style,
      pannelAllocationValue,
      pannelSearchValue,
      pannel_date,
      wrongFormatUploaded,
      SecurityAlreadyUploaded,
    } = this.state;
    const { portfolio, AddManualSecurity } = this.props;
    return (
      <Fragment>
        <div className="pannel__addrow_model">
          <div className="pannel__addrow_model_heading">
            <div>
              lookup and add a security and allocation :{" "}
              <button className="btn" onClick={() => addRowToggleHandler()}>
                {AddManualSecurity ? "add security" : "add row"}
              </button>
            </div>
            {portfolio && portfolio.length > 0 && !AddManualSecurity ? (
              <div>
                <UploadFileButton
                  text="Upload Historical Returns"
                  onHoverStyle={true}
                  eventHandler={(e) => this.xlsxHandler(e)}
                  id="upload_historical_returns"
                />
              </div>
            ) : null}
          </div>

          <div>
            {showAddRowModel && (
              <div className="pannel__addrow_model_content">
                <div className="pannel__addrow_model_content_head">
                  <div>
                    Search and add a security to the list. look up by either
                    securities name or symbol :
                  </div>
                  <div>
                    <input
                      type="text"
                      autoComplete="off"
                      onChange={(e) => this.searchHandler(e)}
                    />
                    {displayAutoCompleteOp && autoCompleteData.length > 0 && (
                      <ul className="add_suggestion">
                        {autoCompleteData.map((data, i) => (
                          <li
                            key={i}
                            index={i}
                            onClick={(e) => this.suggestionHandler(e)}
                          >{`${data["symbol"]} : ${data["fund_name"]}`}</li>
                        ))}
                      </ul>
                    )}
                  </div>
                </div>
                <div className="pannel__addrow_model_content_main">
                  <table className="pannel-content2-table">
                    <thead>
                      <tr>
                        <th>Selected security</th>
                        <th>Asset class</th>
                        <th>classification</th>
                        <th>Style</th>
                        {AddManualSecurity ? null : <th>Date</th>}

                        <th>allocation(%)</th>
                      </tr>
                    </thead>
                    <tbody>
                      {(autoCompleteData.length > 0 &&
                        pannelSearchValue &&
                        pannel_fund_name) ||
                      pannel_asset_class ? (
                        <tr>
                          <td>{pannel_fund_name}</td>
                          <td>{pannel_asset_class}</td>
                          <td>{pannel_classification}</td>
                          <td>{pannel_style}</td>
                          {AddManualSecurity ? null : (
                            <td>
                              <DatePicker
                                closeOnScroll={true}
                                selected={pannel_date}
                                placeholderText="mm-dd-yyyy"
                                onChange={(date) =>
                                  this.setState({ pannel_date: date })
                                }
                              />
                            </td>
                          )}
                          <td>
                            <input
                              type="number"
                              min="0"
                              autoComplete="off"
                              onChange={(e) =>
                                this.setState({
                                  pannelAllocationValue: e.target.value,
                                })
                              }
                              style={{ width: "120px", textAlign: "center" }}
                            />
                          </td>
                        </tr>
                      ) : null}
                    </tbody>
                  </table>

                  {SecurityAlreadyUploaded ? (
                    <div className="SecurityUploadedValidation">
                      <p>
                        Security already part of the universe. Would you like to
                        update allocation?
                      </p>
                      <button
                        className="btn"
                        onClick={() => this.SecurityAlreadyPresentHandler(true)}
                      >
                        {" Yes "}
                      </button>
                      <button
                        className="btn"
                        onClick={() =>
                          this.SecurityAlreadyPresentHandler(false)
                        }
                      >
                        {"No "}
                      </button>
                    </div>
                  ) : null}
                </div>
                <div
                  className="pannel__addrow_model_content_btnRow"
                  style={AddManualSecurity ? { float: "right" } : null}
                >
                  {AddManualSecurity ? (
                    ""
                  ) : (
                    <div className="pannel__addrow_model_content_btnRow_txt1">
                      * Allocation is a required field. Date is optional -
                      today's date shall be used if not populated in{" "}
                      <span style={{ textTransform: "lowercase" }}>
                        mm/dd/yyyy
                      </span>{" "}
                      format
                    </div>
                  )}
                  <div>
                    <button
                      className="btn"
                      onClick={() => this.addRow()}
                      disabled={
                        pannelAllocationValue === null
                          ? true
                          : pannelAllocationValue === ""
                          ? true
                          : false
                      }
                    >
                      Add
                    </button>
                    <button
                      className="btn"
                      onClick={() => this.cancelHandler()}
                    >
                      Cancel
                    </button>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
        {wrongFormatUploaded && (
          <div className="analyze_table_warning">
            <span className="dataWarning ml flex-wrap">
              Please upload xls/xlsx format data.
            </span>
          </div>
        )}
      </Fragment>
    );
  }
}

const mapDispatchToProps = {
  addSymbol: (payload) => ({ type: "ADD_UNIVERSE_LIST_ELEMENT", payload }),
  AddManualSecurityToUniverse: (payload) => ({
    type: "ADD_MANUAL_SECURITY_TO_UNIVERSE",
    payload,
  }),
  AddSecurityToMyUniverse: (payload) => ({
    type: "ADD_MANUAL_SECURITY_TO_MYUNIVERSE",
    payload,
  }),
  setHistoricalReturns: (payload) => ({
    type: "SET_UNIVERSE_LITE_HISTORICAL_RETURNS",
    payload,
  }),
};
export default connect(
  ({
    create: {
      steps: {
        universe: { symbols },
        universeLite: { portfolio },
      },
      SecurityAddedManually,
    },
  }) => ({
    portfolio,
    SecurityAddedManually,
    symbols,
  }),
  mapDispatchToProps
)(Pannel);



// WEBPACK FOOTER //
// ./src/components/pages/Create/universe_lite/Analyze/pannel/pannel.jsx